/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactTranscriptionSegmentFromJSON, StreemApiArtifactTranscriptionSegmentToJSON, } from './';
export function StreemApiListRoomTranscriptionResponseFromJSON(json) {
    return StreemApiListRoomTranscriptionResponseFromJSONTyped(json, false);
}
export function StreemApiListRoomTranscriptionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transcriptionSegments': !exists(json, 'transcription_segments') ? undefined : (json['transcription_segments'].map(StreemApiArtifactTranscriptionSegmentFromJSON)),
        'nextPageToken': !exists(json, 'next_page_token') ? undefined : json['next_page_token'],
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
    };
}
export function StreemApiListRoomTranscriptionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transcription_segments': value.transcriptionSegments === undefined ? undefined : (value.transcriptionSegments.map(StreemApiArtifactTranscriptionSegmentToJSON)),
        'next_page_token': value.nextPageToken,
        'total_size': value.totalSize,
    };
}
//# sourceMappingURL=StreemApiListRoomTranscriptionResponse.js.map